import { eanValido } from './services/gruService';

// Generazione del codice a barre EAN-13 in SVG (vettoriale). Usata dal componente BarcodeEan13,
// dal cartellino e dal PDF della scheda articolo.
// La libreria JsBarcode si carica SOLO quando serve (import dinamico).

const cache = new Map(); // ean -> markup SVG

/** Genera il markup SVG di un EAN-13 (o lancia un errore se non valido). Il risultato è in cache. */
export const generaSvgEan13 = async (ean) => {
  if (!eanValido(ean)) throw new Error('EAN non valido');
  if (cache.has(ean)) return cache.get(ean);

  const { default: JsBarcode } = await import('jsbarcode');
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  JsBarcode(svg, ean, {
    format: 'EAN13',
    width: 2,
    height: 72,
    displayValue: true, // numero leggibile sotto le barre
    font: 'Arial, Helvetica, sans-serif',
    fontSize: 20,
    textMargin: 3,
    margin: 6,
    background: '#ffffff',
    lineColor: '#000000',
  });

  // JsBarcode imposta già il viewBox: si tolgono le dimensioni fisse così l'SVG si adatta al contenitore
  svg.removeAttribute('width');
  svg.removeAttribute('height');
  svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  const markup = svg.outerHTML;
  cache.set(ean, markup);
  return markup;
};

/**
 * Converte il markup SVG in un'immagine PNG nitida (per il PDF).
 * Ritorna { dataUrl, rapporto } con rapporto = altezza / larghezza.
 */
export const svgInPng = (markup, larghezzaPx = 1400) => new Promise((resolve, reject) => {
  const documento = new DOMParser().parseFromString(markup, 'image/svg+xml');
  const svg = documento.documentElement;
  const vb = (svg.getAttribute('viewBox') || '').split(/\s+/).map(Number);
  const [, , w, h] = vb;
  if (!w || !h) {
    reject(new Error('SVG senza viewBox'));
    return;
  }
  const altezzaPx = Math.round((larghezzaPx * h) / w);
  svg.setAttribute('width', String(larghezzaPx));
  svg.setAttribute('height', String(altezzaPx));

  const xml = new XMLSerializer().serializeToString(svg);
  const url = URL.createObjectURL(new Blob([xml], { type: 'image/svg+xml;charset=utf-8' }));
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = larghezzaPx;
    canvas.height = altezzaPx;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, larghezzaPx, altezzaPx);
    ctx.drawImage(img, 0, 0, larghezzaPx, altezzaPx);
    URL.revokeObjectURL(url);
    resolve({ dataUrl: canvas.toDataURL('image/png'), rapporto: altezzaPx / larghezzaPx });
  };
  img.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('Impossibile creare l\'immagine del codice a barre'));
  };
  img.src = url;
});
